"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Admin = void 0;
const privileges_1 = require("./privileges");
const mocks_1 = require("../../mocks");
const property_1 = require("../../decorators/property");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
let Admin = class Admin extends mocks_1.Model {
};
exports.Admin = Admin;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], Admin.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)({ index: true, unique: true }),
    __metadata("design:type", String)
], Admin.prototype, "username", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], Admin.prototype, "password", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => privileges_1.Privileges),
    (0, property_1.Property)({ type: () => privileges_1.Privileges }),
    __metadata("design:type", privileges_1.Privileges)
], Admin.prototype, "privileges", void 0);
exports.Admin = Admin = __decorate([
    (0, mocks_1.index)({ username: 1, password: 1 })
], Admin);
